/**
 * Robust copy-to-clipboard helper.
 * Tries the modern Clipboard API first; falls back to a hidden textarea + execCommand,
 * which works in iframes and older browsers where navigator.clipboard is blocked.
 *
 * Returns: Promise<boolean> — true if copy succeeded.
 */
export async function copyToClipboard(text) {
  if (text == null) return false;
  const value = String(text);

  // Modern path (HTTPS + same-origin top-level)
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(value);
      return true;
    }
  } catch (err) {
    // fall through to legacy path
    console.warn("Clipboard API failed, falling back to execCommand:", err);
  }

  // Legacy fallback: works inside cross-origin iframes
  try {
    const textarea = document.createElement("textarea");
    textarea.value = value;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "fixed";
    textarea.style.top = "0";
    textarea.style.left = "0";
    textarea.style.opacity = "0";
    textarea.style.pointerEvents = "none";
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    textarea.setSelectionRange(0, value.length);
    const ok = document.execCommand("copy");
    document.body.removeChild(textarea);
    return ok;
  } catch (err) {
    console.warn("execCommand copy failed:", err);
    return false;
  }
}
